/**
 * A Typescript workaround of Object.keys, see
 * [YouTube explanation](https://www.youtube.com/watch?v=GW00zebIt0g)
 */
const objectKeys = <O extends {}>(obj: O): Array<keyof O> => {
  return Object.keys(obj) as Array<keyof O>
}

export default objectKeys
